import jwtDecode from "jwt-decode";
import axios from "axios";
import { Auth } from "aws-amplify";

class AuthService {
  setAxiosInterceptors = ({ onLogout }) => {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          this.setSession(null);

          if (onLogout) {
            onLogout();
          }
        }

        return Promise.reject(error);
      }
    );
  };

  handleAuthentication() {
    Auth.currentSession().then(res => {
      this.setSession(res.getAccessToken().getJwtToken());
    });
  }

  handleNewPasswordRequired = (username, oldPwd, newPwd) => new Promise(async (resolve, reject) => {
    // try {
    //   const user = await Auth.signIn(username, oldPwd);
    //   // const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
    //   Auth.completeNewPassword(
    //     user,               // the Cognito User Object
    //     newPwd       // the new password
    //     // OPTIONAL, the required attributes
    //     // {
    //     //   email: 'xxxx@example.com',
    //     //   phone_number: '1234567890'
    //     // }
    //   ).then(user => {
    //     // at this time the user is logged in if no MFA required
    //     Auth.currentSession().then(res => {
    //       this.setSession(res.getAccessToken().getJwtToken());
    //     });
    //     resolve(user);
    //     console.log(user);
    //   }).catch(e => {
    //     console.log(e);
    //   });
    // } catch (error) {
    //   reject(error);
    // }

    Auth.signIn(username, oldPwd)
      .then(user => {
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
          Auth.completeNewPassword(
            user,               // the Cognito User Object
            newPwd      // the new password
            // OPTIONAL, the required attributes
            // {
            //   family_name: 'John',
            //   given_name: 'Smith',
            //   email: 'test@test.com'
            // }
          ).then(user => {
            // at this time the user is logged in if no MFA required

            Auth.currentSession().then(res => {
              this.setSession(res.getAccessToken().getJwtToken());
            });
            resolve(user);


            console.log(user);
          }).catch(e => {
            console.log(e);
          });
        } else {
          // other situations
        }
      }).catch(e => {
      console.log(e);
    });


  });

  loginWithUsernameAndPassword = (email, password) => new Promise(async (resolve, reject) => {
    try {
      const user = await Auth.signIn(email, password);
      console.log(user);
      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        reject(user);
      } else {
        await Auth.currentSession().then(res => {
          this.setSession(res.getAccessToken().getJwtToken());
        });
        resolve(user);
      }
      // if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
      //   // const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
      //   Auth.completeNewPassword(
      //     user,               // the Cognito User Object
      //     '1234abcd',       // the new password
      //     // OPTIONAL, the required attributes
      //     // {
      //     //   email: 'xxxx@example.com',
      //     //   phone_number: '1234567890'
      //     // }
      //   ).then(user => {
      //     // at this time the user is logged in if no MFA required
      //     Auth.currentSession().then(res => {
      //       this.setSession(res.getAccessToken().getJwtToken());
      //     })
      //     resolve(user);
      //     console.log(user);
      //   }).catch(e => {
      //     console.log(e);
      //   });
      // }


      // if (user) {
      //   await Auth.currentSession().then(res => {
      //     this.setSession(res.getAccessToken().getJwtToken());
      //   });
      //   resolve(user);
      // }
    } catch (error) {
      reject(error);
    }


  });

  loginInWithToken = () => new Promise((resolve, reject) => {
    console.log("login in with token called");
    try {
      const userInfo = Auth.currentUserInfo();
      resolve(userInfo);
    } catch (error) {
      reject(error);
    }

    // resolve(Auth.currentUserInfo());

    // axios.get('/api/account/me')
    //   .then((response) => {
    //     if (response.data.user) {
    //       resolve(response.data.user);
    //     } else {
    //       reject(response.data.error);
    //     }
    //   })
    //   .catch((error) => {
    //     reject(error);
    //   });
  });

  logout = () => new Promise((resolve, reject) => {
    try {
      Auth.signOut();
      this.setSession(null);
    } catch (error) {
      console.log("error signing out: ", error);
    }
  });

  setSession = (accessToken) => {
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      axios.defaults.headers.common.Authorization = `${accessToken}`;
    } else {
      localStorage.removeItem("accessToken");
      delete axios.defaults.headers.common.Authorization;
    }
  };

  getAccessToken = () => localStorage.getItem("accessToken");

  isValidToken = (accessToken) => {

    if (!accessToken) {
      return false;
    }

    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;
    console.log("token expires on: " + new Date(decoded.exp * 1000));
    return decoded.exp > currentTime;
  };

  isAuthenticated = () => !!this.getAccessToken();
}

const authService = new AuthService();

export default authService;
